/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmissionGeneratedDocumentExternalEhrDocument } from './PalAuthSubmissionGeneratedDocumentExternalEhrDocument';
import {
    PalAuthSubmissionGeneratedDocumentExternalEhrDocumentFromJSON,
    PalAuthSubmissionGeneratedDocumentExternalEhrDocumentFromJSONTyped,
    PalAuthSubmissionGeneratedDocumentExternalEhrDocumentToJSON,
} from './PalAuthSubmissionGeneratedDocumentExternalEhrDocument';

/**
 * 
 * @export
 * @interface PalAuthSubmissionGeneratedDocument
 */
export interface PalAuthSubmissionGeneratedDocument {
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocument
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocument
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocument
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocument
     */
    s3_key?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocument
     */
    generated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocument
     */
    previous_generated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocument
     */
    type?: PalAuthSubmissionGeneratedDocumentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PalAuthSubmissionGeneratedDocument
     */
    instance_id?: string;
    /**
     * 
     * @type {PalAuthSubmissionGeneratedDocumentExternalEhrDocument}
     * @memberof PalAuthSubmissionGeneratedDocument
     */
    external_ehr_document?: PalAuthSubmissionGeneratedDocumentExternalEhrDocument;
}


/**
 * @export
 */
export const PalAuthSubmissionGeneratedDocumentTypeEnum = {
    SummaryReport: 'summary_report',
    RulesReport: 'rules_report',
    DataPullsReport: 'data_pulls_report',
    SOffenderReport: 's_offender_report',
    MedicationsReport: 'medications_report',
    InsuranceEligibilityCheck: 'insurance_eligibility_check',
    AdvancedAiInsuranceCheck: 'advanced_ai_insurance_check',
    PalAuthSubmissionPackage: 'pal_auth_submission_package',
    PdpmReport: 'pdpm_report'
} as const;
export type PalAuthSubmissionGeneratedDocumentTypeEnum = typeof PalAuthSubmissionGeneratedDocumentTypeEnum[keyof typeof PalAuthSubmissionGeneratedDocumentTypeEnum];


/**
 * Check if a given object implements the PalAuthSubmissionGeneratedDocument interface.
 */
export function instanceOfPalAuthSubmissionGeneratedDocument(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthSubmissionGeneratedDocumentFromJSON(json: any): PalAuthSubmissionGeneratedDocument {
    return PalAuthSubmissionGeneratedDocumentFromJSONTyped(json, false);
}

export function PalAuthSubmissionGeneratedDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionGeneratedDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        's3_key': !exists(json, 's3_key') ? undefined : json['s3_key'],
        'generated_at': !exists(json, 'generated_at') ? undefined : json['generated_at'],
        'previous_generated_at': !exists(json, 'previous_generated_at') ? undefined : json['previous_generated_at'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'instance_id': !exists(json, 'instance_id') ? undefined : json['instance_id'],
        'external_ehr_document': !exists(json, 'external_ehr_document') ? undefined : PalAuthSubmissionGeneratedDocumentExternalEhrDocumentFromJSON(json['external_ehr_document']),
    };
}

export function PalAuthSubmissionGeneratedDocumentToJSON(value?: PalAuthSubmissionGeneratedDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'name': value.name,
        's3_key': value.s3_key,
        'generated_at': value.generated_at,
        'previous_generated_at': value.previous_generated_at,
        'type': value.type,
        'instance_id': value.instance_id,
        'external_ehr_document': PalAuthSubmissionGeneratedDocumentExternalEhrDocumentToJSON(value.external_ehr_document),
    };
}

